import { api } from './api'
import type { UtilityType } from '@riverpark/types'

export interface UtilityTypeTierInput {
  baseRate?: number
  standardCharge?: number
  flatAmount?: number
}

export interface UtilityTypePricingInput {
  developer?: UtilityTypeTierInput | null
  owner?: UtilityTypeTierInput | null
}

export async function listUtilityTypes(): Promise<{ data: UtilityType[] }> {
  return api.get<{ data: UtilityType[] }>('/utilities/types')
}

export async function createUtilityType(body: {
  name: string
  invoicePrefix: string
  description?: string
  billingMethod: 'meter_based' | 'flat_fee'
  unitLabel?: string
  frequency: 'monthly' | 'quarterly' | 'annually'
  generationMode: 'manual' | 'auto'
  billingDay?: number
  pricing: UtilityTypePricingInput
}): Promise<{ data: UtilityType }> {
  return api.post<{ data: UtilityType }>('/utilities/types', body)
}

export async function updateUtilityType(
  id: string,
  body: {
    name?: string
    description?: string
    invoicePrefix?: string
    unitLabel?: string
    frequency?: 'monthly' | 'quarterly' | 'annually'
    generationMode?: 'manual' | 'auto'
    billingDay?: number
    pricing?: UtilityTypePricingInput
  },
): Promise<{ data: UtilityType }> {
  return api.patch<{ data: UtilityType }>(`/utilities/types/${id}`, body)
}

export async function toggleUtilityType(id: string): Promise<{ data: UtilityType }> {
  return api.patch<{ data: UtilityType }>(`/utilities/types/${id}/toggle`, {})
}

export async function deleteUtilityType(id: string): Promise<{ ok: boolean }> {
  return api.delete<{ ok: boolean }>(`/utilities/types/${id}`)
}
